import React from 'react';

import classNames from 'classnames';

import styles from './dummy-checkbox.module.scss';

const DummyCheckbox = ({ label, indeterminate }: { label: React.ReactNode; indeterminate?: boolean }) => {
	return (
		<span className={styles.nonCheckableParent}>
			<span className={classNames(styles.dummyCheckbox, { [styles.indeterminate]: indeterminate })}></span>
			{label}
		</span>
	);
};

export default DummyCheckbox;
